import { ReportProblemTypes } from "../types";
import { createAction } from "./create.action";

export namespace ReportProblemAction {

    export const submit = (model: any, id: number) => createAction(ReportProblemTypes.REQUEST_REPORT_PROBLEM, { model, id });
    export const submitted = () => createAction(ReportProblemTypes.REPORT_PROBLEM_SUBMITTED);

}